<div class="footer-container">
  <div class="footer-sub-container">
    <mwp-thawte></mwp-thawte>
  </div>
  <div class="footer-sub-container">
    <div class="footer-text">
      <span>{{ copyright }}</span>
      <span class="ms-1">{{ appVersion }}</span>
    </div>
  </div>
  <div class="footer-sub-container">
    <div class="footer-link-container">
      @if (!isVersionError) {
      <div class="nav-links">
        @if (!isLoggedIn) {
        <div class="header-menu std-item" [ngClass]="{'active-link': isFaqsItemActive }">
          <div class="menu-header-content no-menu" (click)="openDialog(faqsItem.click)">
            <mwp-text-translate [text]="faqsItem.label" [jsonKey]="faqsItem.jsonKey" />
          </div>
        </div>
        }
        <div class="header-menu std-item" [ngClass]="{'active-link': isTermsOfUseItemActive }">
          <div class="menu-header-content no-menu" (click)="navigateToURL(BaseModulePaths.TermsOfService)">
            <mwp-text-translate text="Terms of Service" jsonKey="termsOfService" />
          </div>
        </div>
        <div class="header-menu" [ngClass]="{'active-link': isPrivacyPolicyItemActive }">
          <div class="menu-header-content no-menu" (click)="navigateToURL(BaseModulePaths.PrivacyPolicy)">
            <mwp-text-translate text="Privacy Policy" jsonKey="privacyPolicy" />
          </div>
        </div>
        <div class="header-menu" [ngClass]="{'active-link': isDataProcessingAddendumItemActive }">
          <div class="menu-header-content no-menu" (click)="navigateToURL(BaseModulePaths.DataProcessingAddendum)">
            <mwp-text-translate text="Data Processing Addendum" jsonKey="dataProcessingAddendum" />
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>